import React, { useEffect, useState, useCallback } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faSave,
  faTimesCircle,
  faSort,
  faDownload,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import api from "../../services/client/api";
import { StepContainer, ModalWrapper, StepTexth4 } from "./styles";
import {
  Label,
  Button,
  Alert,
  Spinner,
  Fade,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { SessionManager } from "../../utils/functions";
const ActivateReports = ({
  token,
  patient,
  onClose,
  username,
  report,
  reports,
}) => {
  const [desfechos, setDesfechos] = useState([]);
  const [dataDesfecho, setDataDesfecho] = useState("");
  const [selectedDesfecho, setSelectedDesfecho] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const session = SessionManager();
  const [order, setOrder] = useState("desc");
  const [confirmModal, setConfirmModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);

  useEffect(() => {
    const fetchLaudos = async () => {
      setDesfechos(reports);
    };

    fetchLaudos();
  }, [token]);

  useEffect(() => {
    if (report) {
      if (report.CodDesfecho != null) {
        setSelectedDesfecho(Number(report.CodDesfecho));
      }

      if (report.DtaDesfecho) {
        // usa a data vinda da API
        const formattedDate = new Date(report.DtaDesfecho)
          .toISOString()
          .split("T")[0];

        setDataDesfecho(formattedDate);
      } else {
        // usa a data atual
        const today = new Date().toISOString().split("T")[0];
        setDataDesfecho(today);
      }
    }
  }, [report]);

  const sortedDesfechos = [...desfechos].sort((a, b) => {
    const dateA = new Date(a.DtaReuniao);
    const dateB = new Date(b.DtaReuniao);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });

  const openConfirmDelete = (report) => {
    setReportToDelete(report);
    setConfirmModal(true);
  };

  const handleRemove = async () => {
    if (!reportToDelete) return;

    try {
      const payload = {
        CodTumorBoard: reportToDelete.CodTumorBoard,
        Ativo: reportToDelete.Ativo,
        username: username,
      };

      const response = await api().user().HideReport(token, payload);

      if (response.status === 200) {
        setConfirmModal(false);
        setReportToDelete(null);
        alert("Alteração salva com sucesso!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Erro ao remover:", error);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <ModalWrapper>
        <button
          onClick={onClose}
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            border: "none",
            background: "#0C2B6E",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 9999,
          }}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>

        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>
          <StepContainer>
            <StepTexth4 style={{ marginTop: 25 }}>
              <b>
                Selecione o paciente que deseja retornar para a listagem de
                reuniões:
              </b>
            </StepTexth4>
          </StepContainer>

          {errorMessage && (
            <Alert color="danger" style={{ textAlign: "center" }}>
              <b>{errorMessage}</b>
            </Alert>
          )}
        </>

        {desfechos.length > 0 ? (
          <Table bordered hover responsive style={{ marginTop: 20 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Nome do Paciente</th>
                <th
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={() => setOrder(order === "desc" ? "asc" : "desc")}
                >
                  Data da reunião{" "}
                  <FontAwesomeIcon
                    icon={faSort}
                    style={{
                      marginLeft: 3,
                      fontSize: "1.0rem",
                      opacity: 0.7,
                    }}
                  />
                </th>
                <th style={{ textAlign: "center" }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {sortedDesfechos.map((item, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{item.NomPaciente}</td>
                  <td style={{ textAlign: "center" }}>
                    {new Date(item.DtaReuniao).toLocaleDateString("pt-BR")}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Button
                      color="success"
                      onClick={() => openConfirmDelete(item)}
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        title={"Remover Desfecho"}
                      />
                    </Button>
                  </td>
                  <Modal
                    isOpen={confirmModal}
                    toggle={() => setConfirmModal(!confirmModal)}
                  >
                    <ModalHeader toggle={() => setConfirmModal(!confirmModal)}>
                      Ativar reunião na listagem
                    </ModalHeader>

                    <ModalBody style={{ textAlign: "center" }}>
                      <b>
                        Tem certeza que deseja retomar a discussão deste
                        paciente na listagem?
                      </b>
                    </ModalBody>

                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={() => setConfirmModal(false)}
                      >
                        Cancelar
                      </Button>

                      <Button color="primary" onClick={handleRemove}>
                        Ativar
                      </Button>
                    </ModalFooter>
                  </Modal>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Spinner />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default ActivateReports;
